export enum WorkflowStatuses {
  New = 1,
  ReadyForPublicHearing = 2,
  PublicHearingPending = 3,
  PublicHearingAdopted = 4,
  PublicHearingRejected = 5,
  AGPending = 6,
  AGApproved = 7,
  AGRejected = 8,
  AGReturnedToAgency = 9,
  GPROPending = 10,
  GPROApproved = 11,
  GPRORejected = 12,
  GPROReturnedToAgency = 13,
  SOSPending = 14,
  ReadyForPromulgation = 15,
  Promulgated = 16,
  DocketPublished = 17,
  DocketTerminated = 18,
  NotificationSentToSubscribers = 19,
  NotificationSentToSOS = 20,
  NotificationSentToGPRO = 21,
  NotificationSentToAG = 22,
  RejectionExplanationSentToAgency = 23,
  EmergencyNew = 24,
  NonSubstantiveNew = 25,
  EmergencyGPROPending = 26,
  EmergencyGPROApprove = 27,
  EmergencyGPROReturnedToAgency = 28,
  NotificationSentToExecutiveBoard = 29,
  NotificationSentToAgency = 30
}